<template>
  <path
    fill="currentColor"
    d="M3.125 2.5C2.77982 2.5 2.5 2.77982 2.5 3.125C2.5 3.47018 2.77982 3.75 3.125 3.75L6.875 3.75L6.875 16.875C6.875 17.2202 7.15482 17.5 7.5 17.5C7.84518 17.5 8.125 17.2202 8.125 16.875L8.125 3.75L11.875 3.75C12.2202 3.75 12.5 3.47018 12.5 3.125C12.5 2.77982 12.2202 2.5 11.875 2.5H3.125Z" />
  <path
    fill="currentColor"
    d="M11.25 8.75C10.9048 8.75 10.625 9.02982 10.625 9.375C10.625 9.72018 10.9048 10 11.25 10H13.75V16.875C13.75 17.2202 14.0298 17.5 14.375 17.5C14.7202 17.5 15 17.2202 15 16.875V10H17.5C17.8452 10 18.125 9.72018 18.125 9.375C18.125 9.02982 17.8452 8.75 17.5 8.75L11.25 8.75Z" />
</template>
